// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicosCategorias_CarregaCategoriasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/servicos_categorias/carrega_categorias
 *
 * Fetches all service categories. No body required.
 */
import { registerContract } from './validate'

export interface ServicosCategorias_CarregaCategoriasInput {}

registerContract('ServicosCategorias_CarregaCategoriasInput', {})
